import { format } from "date-fns";
import { DATE_TIME_FORMAT } from "@/constants/constants";

export const renderCustomFieldValue = (
	value: string | number | boolean,
	dataType: string,
): string => {
	if (value !== false && !value) {
		return "—";
	}
	switch (dataType) {
		case "string":
			return String(value);
		case "boolean":
			return value ? "True" : "False";
		case "datetime":
			return format(new Date((value as number) * 1000), DATE_TIME_FORMAT);
		default:
			return String(value);
	}
};
